import * as React from 'react';
import AppLayout from '../AppLayout/AppLayout';
import ContentModalV2 from '../ContentModal/ContentModalV2';
interface PageProps {
  title?: string;
  backTo?: string;
  hideNavigation?: boolean;
}

const Page: React.SFC<PageProps> = ({
  title,
  backTo,
  hideNavigation,
  children,
}) => {
  return (
    <>
      <AppLayout hideNavigation={hideNavigation} backTo={backTo}>
        {children}
      </AppLayout>
      <ContentModalV2 />
    </>
  );
};

export default Page;
